<template>
  <a-modal
    class="commission-detail-modal"
    :title="null"
    :get-container="container"
    :width="1200"
    :footer="null"
    :open="true"
    @ok="emit('hideCommissionDetailModal')"
    @cancel="emit('hideCommissionDetailModal')"
  >
    <div class="detail">
      <div
        v-for="(key, index) in Object.keys(keyTitleMap)"
        :key="index"
        class="item"
      >
        <div
          v-if="key == 'eventTime' || key == 'updateTime'"
          :class="key"
        >
          <label>{{ keyTitleMap[key] }}:</label>
          {{ moment(commission[key]).format('YYYY-MM-DD HH:mm:ss') }}
        </div>
        <div
          v-else-if="key == 'shortLink'"
          :class="key"
        >
          <label>{{ keyTitleMap[key] }}:</label>
          <a
            :href="commission[key]"
            target="_blank"
          >{{ commission[key] || '-' }}</a>
        </div>
        <div
          v-else-if="key === 'status'"
          :class="commission[key].replace(' ', '-').toLowerCase()"
        >
          <label>{{ keyTitleMap[key] }}:</label>
          {{ commission.status }}
        </div>
        <div
          v-else-if="key === 'note'"
          ref="noteEditCell"
          :class="key"
        >
          <label>Note:</label>
          {{ commission.note || '-' }}
        </div>
        <div
          v-else
          :class="key"
        >
          <label>{{ keyTitleMap[key] }}:</label>{{ commission[key] || '-' }}
        </div>
      </div>
    </div>
    <div
      v-if="showNoteEditInCommissionModal"
      v-click-outside="hideNoteEditModal"
      class="note-edit-container"
      :style="{ ...noteEditPosition }"
    >
      <a-textarea
        v-model:value="newNoteContent"
        :rows="2"
        placeholder="Click to enter"
      />
      <a-button
        type="primary"
        :style="{ height: noteEditPosition.height }"
        @click="
          emit('saveNote', commission[0].id, commissionIndex, newNoteContent)
        "
      >
        Done
      </a-button>
    </div>
  </a-modal>
</template>

<script setup>
import moment from 'moment'
import { ref } from 'vue'
import { TABLE_COLUMNS, getElementPosition } from './utils'
import vClickOutside from '../../../directives/click-outside.js'

const noteEditCell = ref()
const props = defineProps({
  container: { type: [Object, String], default: undefined },
  commission: { type: Object, required: true },
  commissionIndex: { type: Number, required: true },
})
const emit = defineEmits([
  'saveNote',
  'setShowLogModalId',
  'hideCommissionDetailModal',
])
const keyTitleMap = {}
TABLE_COLUMNS.forEach((item) => {
  if (item.dataIndex != 'actions') {
    keyTitleMap[item.dataIndex] = item.title || item.key
  }
})

delete props.commission['affiliateId']

const noteEditPosition = ref(null)
const newNoteContent = ref(props.commission.note)
const showNoteEditInCommissionModal = ref(false)

function hideNoteEditModal() {
  showNoteEditInCommissionModal.value = false
}

function setNoteEditModal() {
  showNoteEditInCommissionModal.value = true
  noteEditPosition.value = {
    ...getElementPosition(
      noteEditCell.value[0],
      noteEditCell.value[0].closest('.ant-modal-content')
    ),
    height: noteEditCell.value[0].offsetHeight - 2 + 'px',
  }
}

defineExpose({
  // 父组件可以调用的方法
  hideNoteEditModal,
  setNoteEditModal,
})
</script>

<style lang="less" scoped>
@import './common.less';

.detail {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(3, 1fr);
  .item {
    font-size: 16px;
    line-height: 32px;
    word-break: break-all;
  }
  label {
    color: #999;
    margin-right: 6px;
    white-space: nowrap;
  }
  .note {
    display: flex;
  }
}
</style>